import React, {useCallback, useState} from 'react';
import {Link, useNavigate} from 'react-router-dom';
import {api} from './Api.js';
import logo from '../logo.svg';
import 'flag-icons/css/flag-icons.min.css';

const LEVEL_OPTIONS = [['A1', 'A1 — Beginner'], ['A2', 'A2 — Elementary'], ['B1', 'B1 — Intermediate'], ['B2', 'B2 — Upper intermediate'], ['C1', 'C1 — Advanced'], ['C2', 'C2 — Proficient']];

const SignUp = ({showNotification}) => {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [levels, setLevels] = useState({vocabularyLevel: 'B1', writingLevel: 'B1', speakingLevel: 'B1', grammarLevel: 'B1'});
    const [language, setLanguage] = useState('EN');
    const [errors, setErrors] = useState({});
    const [waiting, setWaiting] = useState(false);
    const [error, setError] = useState(false);
    const navigate = useNavigate();

    const signUp = useCallback(async (data) => {
        setWaiting(true);
        const response = await api.signUp(data, navigate, showNotification);
        if (api.isValidResponse(response)) navigate('/');
        else setError(true);
        setWaiting(false);
    }, [navigate, showNotification]);

    const onSubmit = useCallback((event) => {
        event.preventDefault();
        const nextErrors = {};
        if (!username) nextErrors.username = 'Enter a username';
        else if (username.length < 4) nextErrors.username = 'Use at least 4 characters';
        if (!password) nextErrors.password = 'Enter a password';
        else if (password.length < 4) nextErrors.password = 'Use at least 4 characters';
        if (password !== confirmPassword) nextErrors.confirmPassword = 'Passwords do not match';
        setErrors(nextErrors);
        setError(false);
        if (Object.keys(nextErrors).length) return;
        signUp({username, password, ...levels, language});
    }, [username, password, confirmPassword, levels, language, signUp]);

    const fields = [['vocabularyLevel', 'Vocabulary'], ['writingLevel', 'Writing'], ['speakingLevel', 'Speaking'], ['grammarLevel', 'Grammar']];
    return <main className="auth-page auth-page--wide">
        <form className="auth-card auth-card--wide surface-card" onSubmit={onSubmit} noValidate>
            <div className="auth-brand"><img src={logo} alt="anglisik"/><span>anglisik</span></div>
            <div className="auth-heading"><h1>Create your account</h1><p>Set your starting point for each skill.</p></div>
            <div className="auth-fields auth-fields--two">
                <label><span className="field-label">Username</span><input className="field-control" autoComplete="username" value={username} onChange={(event) => setUsername(event.target.value)}
                                                                           aria-invalid={Boolean(errors.username)}/>{errors.username && <span className="field-error">{errors.username}</span>}</label>
                <div className="auth-field-placeholder" aria-hidden="true"/>
                <label><span className="field-label">Password</span><input className="field-control" type="password" autoComplete="new-password" value={password}
                                                                           onChange={(event) => setPassword(event.target.value)} aria-invalid={Boolean(errors.password)}/>{errors.password &&
                    <span className="field-error">{errors.password}</span>}</label>
                <label><span className="field-label">Confirm password</span><input className="field-control" type="password" autoComplete="new-password" value={confirmPassword}
                                                                                   onChange={(event) => setConfirmPassword(event.target.value)}
                                                                                   aria-invalid={Boolean(errors.confirmPassword)}/>{errors.confirmPassword &&
                    <span className="field-error">{errors.confirmPassword}</span>}</label>
            </div>
            <fieldset className="auth-fieldset">
                <legend>Practice language</legend>
                <div className="choice-row">
                    {[['EN', 'gb', 'English'], ['RS', 'rs', 'Serbian']].map(([code, flag, label]) => <button type="button" key={code}
                                                                                                             className={`choice-button ${language === code ? 'is-selected' : ''}`}
                                                                                                             onClick={() => setLanguage(code)} aria-pressed={language === code}><span
                        className={`fi fi-${flag}`}/>{label}</button>)}
                </div>
            </fieldset>
            <fieldset className="auth-fieldset">
                <legend>Skill levels</legend>
                <p className="field-description">You can update these anytime in your profile.</p>
                <div className="auth-fields auth-fields--two">
                    {fields.map(([key, label]) => <label key={key}><span className="field-label">{label}</span><select className="browser-default field-control" value={levels[key]}
                                                                                                                       onChange={(event) => setLevels((current) => ({
                                                                                                                           ...current,
                                                                                                                           [key]: event.target.value
                                                                                                                       }))}>{LEVEL_OPTIONS.map(([value, text]) => <option key={value}
                                                                                                                                                                          value={value}>{text}</option>)}</select></label>)}
                </div>
            </fieldset>
            {error && <div className="form-alert" role="alert"><i className="material-icons" aria-hidden="true">error_outline</i> Account creation failed. Check your details and try again.</div>}
            <button className="button-primary auth-submit" type="submit" disabled={waiting}>{waiting ? <><span className="loader-dot"/> Creating account…</> : <>Create account <i
                className="material-icons" aria-hidden="true">arrow_forward</i></>}</button>
            <p className="auth-footer">Already have an account? <Link to="/login">Sign in</Link></p>
        </form>
    </main>;
};

export default SignUp;
